export function getUrl(aAction, aData) {
    const url = {
        insert: {url:'/document/basketengineinsert', method: 'patch'},
        mailinsert: {url:'/document/basketengineinsert', method: 'patch'},
        savemail: {url:'/document/basketengineinsert', method: 'patch'},
        copy: {url:'/document/basketenginecopy', method: 'patch'},
        move: {url:'/document/basketenginemove', method: 'patch'},
        delete: {url:'/document/basketenginedelete', method: 'post'},
        validmail: {url:'/document/basketenginevalidate', method: 'patch'},
        validbsk: {url:'/document/basketenginevalidate', method: 'patch'},
        validbskaction: {url:'/document/basketenginevalidate', method: 'patch'},
        addtextpdf: {url:'/document/updateaddtextpdf', method: 'patch'},
        annot: {url:'/document/updateannot', method: 'patch'},
        graphsign: {url:'/document/updategraphsign', method: 'patch'},
        stamp: {url:'/document/updatestamp', method: 'patch'},
        deleteged: {url:'/document/delete', method: 'post'},
        comment: {url:'/document/updatecomment', method: 'patch'},
        index: {url:'/document/updateindex', method: 'patch'},
        sendbsk: {url:'/document/atftobsk', method: 'patch'},
        deldocvariable: {url:'/document/deldocvariablelist', method: 'patch'},
        changedoc: {url:'/document/changedoc', method: 'patch'},
        updatethumbs: {url:'/document/updatethumbs', method: 'patch'},
        delattachedfile: {url:'/document/delattachedfile', method: 'post'},
        dwnlattachedfile: {url:'/document/dwnlattachedfile', method: 'post'},
        dwnlattachedgedfile: {url:'/document/dwnlattachedgedfile', method: 'post'},
        renattachedfile: {url:'/document/renattachedfile', method: 'post'},
        cnvattachedfile: {url:'/document/cnvattachedfile', method: 'post'},
        convertattachedfile: {url:'/document/convertattachedfile', method: 'post'},
        getactions: {url:'/document/getactions', method: 'post'},
        getversionfile: {url:'/document/getversionfile', method: 'post'},
        getversioncopy: {url:'/document/getversioncopy', method: 'post'},
        unlockdocuments: {url:'/document/unlockdocuments', method: 'patch'},      
        logoutdocuments: {url:'/document/logoutdocuments', method: 'patch'},      
        verifycheckout: {url:'/document/verifycheckout', method: 'post'},
        getlockdocs: {url:'/document/getlockdocs', method: 'post'},        
        getdeletedocs: {url:'/document/getdeletedocs', method: 'post'},               
        checkout: {url:'/document/lockdocuments', method: 'patch'},
        checkin: {url:'/document/checkin', method: 'patch'},
        fulltextbis: {url:'/document/fulltextbis', method: 'post'},
        execrequestsearch: {url:'/document/execrequestsearch', method: 'post'},
        execrequestsearchapi: {url:'/document/execrequestsearchapi', method: 'post'},
        execrequestsearchbsk: {url:'/document/execrequestsearchbsk', method: 'post'},
        exectreesearch: {url:'/document/exectreesearch', method: 'post'},
        exectreesearchapi: {url:'/document/exectreesearchapi', method: 'post'},
        senddocmail: {url:'/document/senddocmail', method: 'post'},
        getdatasetrequest: {url:'/document/getdatasetrequest', method: 'post'},
        setversion: {url:'/document/setversion', method: 'post'},
        execstat: {url:'/document/execstat', method: 'post'},
        export: {url:'/document/export', method: 'post'},
        exportexcel: {url:'/exportexcel', method: 'post'},
        getdocument: {url:'/document/getdocument', method: 'post'},
        getdocumentcopy: {url:'/document/getdocumentcopy', method: 'post'},
        clone: {url:'/document/clonedocument', method: 'post'},
        infos: {url: '/document/' + aData + '/false/infos', method: 'get'},
        infosupdate: {url: '/document/' + aData + '/true/infos', method: 'get'},
        comments: {url: '/document/' + aData + '/comments', method: 'get'},
        traces: {url: '/document/' + aData + '/traces', method: 'get'},
        baskets: {url: '/document/' + aData + '/baskets', method: 'get'},
        getformatlist: {url:'/document/getformatlist', method: 'post'},
        getrootpath: {url:'/document/getrootpath', method: 'post'},
        getrootpathapi: {url:'/document/getrootpathapi', method: 'post'},
        getrootlist: {url:'/document/getrootlist', method: 'post'},        
        getchildroot: {url:'/document/getchildroot', method: 'post'},               
        getindex: {url: '/document/' + aData + '/index', method: 'get'},
        getbaskets: {url: '/document/' + aData + '/baskets', method: 'get'},
        getdocatfs: {url: '/document/' + aData + '/atfs', method: 'get'},
        getversionlist: {url: '/document/' + aData + '/versionlist', method: 'get'},
        getbskcount: {url: '/document/getbskcount', method: 'get'},
        getbasketlistold: {url: '/document/getbasketlistold', method: 'post'},                
        checkreset: {url:'/config/checkreset', method: 'post'},
        setpass: {url:'/config/setpass', method: 'post'},
        setcombo: {url:'/config/setcombo', method: 'post'},
        setdelegate: {url:'/config/setdelegate', method: 'post'},
        getuserlistfilter: {url:'/config/getuserlistfilter', method: 'post'},
        getvariablelist: {url: '/config/getvariablelist', method: 'get'},
        getcustomeditorlist: {url: '/config/getcustomeditorlist', method: 'post'},
        getalluserlist: {url: '/config/getalluserlist', method: 'post'},
        getuserdata: {url: '/config/getuserdata', method: 'post'},
        setuserdata: {url: '/config/setuserdata', method: 'post'},
        deleteuser: {url: '/config/delete', method: 'post'},
        getallgrouplist: {url: '/config/getallgrouplist', method: 'post'},        
        getgroupdata: {url: '/config/getgroupdata', method: 'post'},
        getuserlistgroup: {url: '/config/getuserlistgroup', method: 'get'},
        setgroupdata: {url: '/config/setgroupdata', method: 'post'},
        deletegroup: {url: '/config/deletegroup', method: 'post'},
        getgroupvariablelist: {url: '/config/getgroupvariablelist', method: 'get'},
        geteditorinfos: {url: '/config/geteditorinfos', method: 'post'},
        getgrouplist: {url: '/config/getgrouplist', method: 'get'},
        getprofillist: {url: '/config/getprofillist', method: 'get'},
        getuserlist: {url: '/config/getuserlist', method: 'get'},
        getdelegatelist: {url: '/config/getdelegatelist', method: 'get'},
        getconfiggeneral: {url: '/config/general', method: 'get'},
        getconfiginfos: {url: '/config/informations', method: 'get'},
        getmodelstatlist: {url: '/config/getmodelstatlistbyuser', method: 'post'},
        getuserinfos: {url: '/config/userinfos', method: 'post'},
        getbasketlistbyuserrequest: {url: '/config/basketlistbyuserrequest', method: 'post'},
        getbskvariablelist: {url: '/config/basketvariablelist', method: 'post'},
        getbasketlistbyname: {url: '/config/basketlistbyname', method: 'post'},                        
        getaccessright: {url: '/config/accessright', method: 'get'},
        setright: {url: '/config/setright', method: 'post'},
        getcategorymodel: {url: '/config/getcategorymodel', method: 'post'},    
        getbinary: {url: '/config/getbinary', method: 'post'},    
        getpreviewdoc: {url: '/config/getpreviewdoc', method: 'post'},    
        setbasketdata: {url: '/config/setbasketdata', method: 'post'},  
        getallbsklist: {url: '/config/getallbsklist', method: 'post'},        
        senddocument: {url: '/document/senddocument', method: 'post'},            
        senddocumentcollect: {url: '/collect/senddocument', method: 'post'},            
        getrequestssys: {url: '/request/getrequestsys', method: 'get'},
        getrequestsbyuserbsk: {url: '/request/getrequestlistuserbsk', method: 'post'},
        getrequestsbyuser: {url: '/request/getrequestlistuser', method: 'get'},
        getlastrequests: {url: '/request/getlastrequest', method: 'get'},
        getrequests: {url: '/request/getrequestlist', method: 'get'},
        getrequest: {url: '/request/' + aData + '/getdata', method: 'get'},
        updaterequest: {url:'/request/update', method: 'patch'},
        deleterequest: {url: '/request/' + aData + '/delete', method: 'delete'},
        importparamrequests: {url: '/request/import', method: 'post'},                
        geteditorright: {url: '/editorright/' + aData + '/getdata', method: 'get'},
        geteditorrights: {url: '/editorright/geteditorrightlist', method: 'get'},
        updateeditorright: {url: '/editorright/update', method: 'patch'},
        deleteeditorright: {url: '/editorright/' + aData + '/delete', method: 'delete'},
        getdelegateright: {url: '/delegateright/' + aData + '/getdata', method : 'get'},
        getdelegateallows: {url: '/delegateright/getdelegateallow', method: 'get'},
        getdelegaterights: {url: '/delegateright/getdelegaterightlist', method: 'get'},
        updatedelegateright: {url: '/delegateright/update', method: 'patch'},
        deletedelegateright: {url: '/delegateright/' + aData + '/delete', method: 'delete'},
        getadmindelegatelist: {url: '/admindelegate/getadmindelegatelist', method: 'get'},
        getadmindelegate: {url: '/admindelegate/' + aData + '/getdata', method : 'get'},
        updateadmindelegate: {url: '/admindelegate/update', method: 'patch'},
        deleteadmindelegate: {url: '/admindelegate/' + aData + '/delete', method: 'delete'},
        getadmindelagateuser: {url: '/admindelegate/getadmindelegateuser', method: 'get'},
        getresult: {url: '/result/' + aData + '/getdata', method: 'get'},
        getresults: {url: '/result/getresultlist', method: 'get'},
        getresultsbyuser: {url: '/result/getresultlistuser', method: 'get'},
        updateresult: {url:'/result/update', method: 'patch'},
        deleteresult: {url: '/result/' + aData + '/delete', method: 'delete'},
        importparamresults: {url: '/result/import', method: 'post'},
        getcustomright: {url: '/custright/' + aData + '/getdata', method: 'get'},        
        getcustomrights: {url: '/custright/getcustrightlist', method: 'get'},
        setcustomright: {url: '/custright/update', method: 'patch'},
        deletecustomright: {url: '/custright/' + aData + '/delete', method: 'delete'},        
        getreqbasket: {url: '/reqbsk/' + aData + '/getdata', method: 'get'},
        getreqbaskets: {url: '/reqbsk/getreqbsklist', method: 'get'},
        getbasketsreq: {url: '/reqbsk/getbskreqlist', method: 'get'},
        getresbasket: {url: '/resbsk/' + aData + '/getdata', method: 'get'},
        getresbaskets: {url: '/resbsk/getresbsklist', method: 'get'},
        getbasketsres: {url: '/resbsk/getbskreslist', method: 'get'},
        getresfrombasket: {url: '/resbsk/getresfrombasket', method: 'post'},
        deleteresbsk: {url: '/resbsk/' + aData + '/delete', method: 'delete'},
        updateresbsk: {url:'/resbsk/update', method: 'patch'},   
        getuserbsklist: {url: '/userbsk/getuserbsklist', method: 'get'},
        getbskuserlist: {url: '/userbsk/getbskuserlist', method: 'get'},
        getuserbaskets: {url: '/userbsk/getuserbaskets', method: 'get'},
        getgroupbaskets: {url: '/userbsk/getgroupbaskets', method: 'get'},
        updateuserbsk: {url:'/userbsk/update', method: 'patch'},
        deleteuserbsk: {url: '/userbsk/delete', method: 'post'},        
        getuserbasket: {url: '/userbsk/getdata', method: 'post'},
        deletereqbsk: {url: '/reqbsk/' + aData + '/delete', method: 'delete'},
        updatereqbsk: {url:'/reqbsk/update', method: 'patch'},        
        getfulltextrequestbyuser: {url: '/fulltext/getrequestlistuser', method: 'get'},
        updatefulltext: {url: '/fulltext/update', method: 'patch'},
        deletedfulltext: {url: '/fulltext/' + aData + '/delete', method: 'delete'},
        getlastviewdocs: {url: '/lastviewdoc/getlastviewdoc', method: 'get'},
        getlastactiondocs: {url: '/lastactiondoc/getlastactiondoc', method: 'get'},
        getlastconnections: {url: '/lastconnection/getlastconnection', method: 'get'},
        dellastconnections: {url: '/lastconnection/dellastconnection', method: 'post'},
        getbatchlist: {url: '/document/batch/getbatchlist', method: 'get'},
        getbatchdisp: {url: '/document/batch/getbatchdisp', method: 'get'},
        getbatchfile: {url: '/document/batch/getbatchfile', method: 'post'},
        deletebatch: {url: '/document/batch/deletebatch', method: 'post'},
        getnotiflist: {url: '/notif/getnotiflist', method: 'get'},
        getallnotiflist: {url: '/notif/getallnotiflist', method: 'get'},
        getactivnotiflist: {url: '/notif/getactivnotiflist', method: 'get'},
        updatenotif: {url:'/notif/update', method: 'post'},
        addnotif: {url:'/notif/add', method: 'post'},
        deletenotif: {url:'/notif/delete', method: 'post'},
        deleteconnect: {url: '/lastconnection/' + aData + '/delete', method: 'delete'},        
        getlogtrack: {url: '/logtrack/getlogtrack', method: 'get'},
        dellogtrack:  {url: '/logtrack/dellogtrack', method: 'post'},
        getlogs: {url: '/logs/getlogs', method: 'get'},
        readlog: {url: '/logs/readlog', method: 'post'},
        getdelegatetusers: {url: '/delegate/getdelegatelistuser', method: 'get'},
        updatepreference: {url:'/preference/updatepreference', method: 'patch'},
        updateprefsmtp: {url:'/preference/updateprefsmtp', method: 'patch'},
        updateallpreference: {url:'/preference/updateallpreference', method: 'patch'},
        getuserpreference: {url: '/preference/getuserpreference', method: 'get'},
        getusedrequests: {url: '/prefrequest/getprefrequest', method: 'get'},
        gettreesearch: {url: '/treesearch/getrequestlistuser', method: 'get'},
        updatetreesearch: {url:'/treesearch/update', method: 'patch'},
        deletetreesearch: {url: '/treesearch/' + aData + '/delete', method: 'delete'},        
        setuserbskpos: {url:'/userbskpos/update', method: 'patch'},
        getuserbskpos: {url: '/userbskpos/getuserbskpos', method: 'get'},
        getuserbskfilters: {url:'/userbskfilter/getuserbskfilter', method: 'post'},
        updatebskfilter: {url:'/userbskfilter/update', method: 'patch'},

        gettagbaselist: {url: '/tagbase/gettagbaselist', method: 'get'},
        updatetagbase: {url:'/tagbase/update', method: 'patch'},
        gettagbase: {url: '/tagbase/' + aData + '/getdata', method: 'get'},
        deletetagbase: {url: '/tagbase/' + aData + '/delete', method: 'delete'},        

        getsupervbaselist: {url: '/supervbase/getsupervbaselist', method: 'get'},
        updatesupervbase: {url:'/supervbase/update', method: 'patch'},
        getsupervbase: {url: '/supervbase/' + aData + '/getdata', method: 'get'},
        deletesupervbase: {url: '/supervbase/' + aData + '/delete', method: 'delete'},      

        gettagbasket: {url: '/tagbsk/' + aData + '/getdata', method: 'get'},
        gettagbaskets: {url: '/tagbsk/gettagbsklist', method: 'get'},
        getbasketstag: {url: '/tagbsk/getbsktaglist', method: 'get'},
        deletetagbsk: {url: '/tagbsk/' + aData + '/delete', method: 'delete'},
        updatetagbsk: {url:'/tagbsk/update', method: 'patch'},
    
        getmenubaskets: {url: '/menubsk/getmenubsklist', method: 'get'},
        getbasketsmenu: {url: '/menubsk/getbskmenulist', method: 'get'},
        getmenulist: {url: '/menubsk/getmenulist', method: 'get'},
        getmenubasket: {url: '/menubsk/' + aData + '/getdata', method: 'get'},
        deletemenubsk: {url: '/menubsk/' + aData + '/delete', method: 'delete'},
        updatemenubsk: {url:'/menubsk/update', method: 'patch'},

        getbskcolorlist: {url: '/colorbsk/getcolorbsklist', method: 'get'},
        setbskcolor: {url:'/colorbsk/update', method: 'patch'},
        setdocks: {url:'/docks/update', method: 'patch'},
        
        setmodeldocks: {url:'/docks/model', method: 'patch'},        
        setbasketdocks: {url:'/docks/basket', method: 'patch'},  
        getdocksbasket: {url: '/docks/basket', method: 'post'},   
        setdetaildocks: {url:'/docks/detail', method: 'patch'},
        resetdocks: {url:'/docks/reset', method: 'patch'},
        getdocksdetails: {url: '/docks/details', method: 'post'},   
        delmodeldocks: {url: '/docks/delete', method: 'post'},
        getalldocks: {url: '/docks/getalldocks', method: 'post'},                
        compdocks: {url: '/docks/compdocks', method: 'post'},        
        importparamdocks: {url: '/docks/import', method: 'post'},        
        
        setdocumentcopy: {url:'/document/setdocumentcopy', method: 'post'},
        exportparam: {url: '/export', method: 'post'},

        setaccess: {url:'/access/update', method: 'patch'},
        getaccess: {url:'/access/getpage', method: 'post'},
        getcrypt: {url: '/crypt', method: 'post'},
        getcustmenubaselist: {url: '/custmenu/getcustmenubaselist', method: 'get'},
        deletecustmenubase: {url: '/custmenu/' + aData + '/delete', method: 'delete'},   
        getcustmenubase: {url: '/custmenu/' + aData + '/getdata', method: 'get'},
        updatecustmenubase: {url:'/custmenu/update', method: 'patch'},
        testsmtp: {url:'/mail/send', method: 'post'},
        getmaillist: {url: '/mail/getmaillist', method: 'get'},
        resendmail: {url:'/mail/resend', method: 'post'},
        deletemail: {url: '/mail/delete', method: 'post'},
    };
    return url[aAction];
}
